import { render, staticRenderFns } from "./UsuarioAtivarDesativar.vue?vue&type=template&id=0b9d97e2"
import script from "./UsuarioAtivarDesativar.vue?vue&type=script&lang=js"
export * from "./UsuarioAtivarDesativar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports